export const styles = theme => ({
	printButton: {
		marginTop: '16px',
	},
});
